module.exports = __webpack_public_path__ + "resources/img/img-logo-secureguard.84e0f95a597c8fb12ec29277b0d1a8d6.png";